import styled from 'styled-components'

interface EmbedWrapperProps {
  patientHasAlreadyCompleted: boolean
}

export const Container = styled.div`
  .MedicalEvaluation__Disclaimer {
   color: #898989;

   b {
    font-style: italic;
   }
  }

  .MedicalEvaluation__Title {
    @media (max-width: 768px) {
      font-size: 21px;
      text-align: center;
    }
  }

  .MedicalEvaluation__Form {
    width: 100%;
    height: 100%;
  }
`

export const EmbedWrapper = styled.div<EmbedWrapperProps>`
  width: 100%;
  box-shadow: 0px 1px 3px #00000029;
  border-radius: 10px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  height: ${(props) => props.patientHasAlreadyCompleted ? '397px' : 'calc(100vh - 25rem)'};
  margin: 27px 0 20px 0;

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`